import {useContext} from 'react';

export const INVALID_USER_FOR_SITE = 'INVALID_USER_FOR_SITE';
export const TIMEOUT = 'TIMEOUT';
export const TOKEN_EXPIRED = 'TOKEN_EXPIRED';
export const INTERNAL_ERROR = 'INTERNAL_ERROR';

import AppStateContext from "../app/context/appStateContext";

export const APIHelper = () => {
  const { setAppStateDetails } = useContext(AppStateContext);

  const run = async (functionToCall: (...any) => Promise<any>, callbacks: (data: [] | string | {})=> ({} | void), params: [...any]) => {
    try {
      let response = await functionToCall(...params);
      callbacks(response);
    } catch (err) {
      switch (err) {
        case TOKEN_EXPIRED:
          setAppStateDetails({
            token: 'expired'
          });
          break;
        case TIMEOUT:
          callbacks('timeout');
          break;
        case INVALID_USER_FOR_SITE:
          throw(err);
          break;
      }
    }
  };

  return {
    run
  };
};

export default APIHelper;